<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible.sync="visible"
    width="900px"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => close()"
    destroy-on-close
    append-to-body
  >
    <ChooseOrderGoods
      ref="chooseOrderGoodsInner"
      :height="height"
      :data="data"
      @changePopNum="changePopNum"
    />
    <span slot="footer">
      <el-badge class="item" style="margin-right: 12px;">
        <el-button size="small" @click="close()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
      </el-badge>
      <el-badge :value="checkNum" class="item">
        <el-button type="primary" size="small" @click="confirm()">
          {{ $l('INDEX.btn_confirm') || '确认' }}
        </el-button>
      </el-badge>
    </span>
  </el-dialog>
</template>
<script>
import ChooseOrderGoods from './index.vue'
export default {
  components: { ChooseOrderGoods },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    height: { type: Number, default: 360 },
    data: { type: Object, default: () => {} },
  },
  data() {
    return {
      checkNum: 0,
    }
  },
  methods: {
    confirm() {
      const tableList = this.$refs.chooseOrderGoodsInner.choiceData()
      if (!tableList) return
      this.data.orderGoodsCodeList = tableList.map((m) => m.orderGoodsCode)
      this.$emit('confirm', this.data)
      this.close()
    },
    changePopNum(num) {
      this.checkNum = num || 0
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
